const cardData = [
  {
    id: 1,
    title: '某顶流小生深夜密会神秘女子，酒店共度八小时',
    summary: '据知情人士爆料，该顶流小生近期频繁出入某五星级酒店，与一名神秘女子关系密切。多位目击者证实两人举止亲密。',
    tag: '娱乐圈',
    time: '2小时前',
    hot: '9.8万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20luxury%20hotel%20night%20scene%20with%20silhouetted%20figures%2C%20warm%20amber%20and%20deep%20red%20lighting%2C%20mysterious%20atmosphere%2C%20modern%20digital%20art%20style%2C%20cinematic%20composition%2C%20soft%20blur%20background%2C%20paparazzi%20photography%20aesthetic%2C%20high%20contrast%20shadows%2C%20professional%20editorial%20quality&width=800&height=500&seq=card-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '知名女星婚变内幕曝光，第三者身份浮出水面',
    summary: '该女星与富商丈夫的婚姻疑似出现裂痕，多方消息指向第三者介入。圈内人士透露离婚协议已在草拟中。',
    tag: '娱乐圈',
    time: '5小时前',
    hot: '7.2万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20illustration%20of%20broken%20relationship%20symbolism%2C%20split%20rings%20and%20fading%20figures%2C%20warm%20red%20and%20muted%20gold%20tones%2C%20emotional%20atmosphere%2C%20modern%20minimalist%20digital%20art%2C%20abstract%20storytelling%20composition%2C%20soft%20gradient%20background%2C%20professional%20magazine%20editorial%20style&width=800&height=500&seq=card-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '网红主播偷税漏税被查，金额高达数千万',
    summary: '税务部门近期对多名头部网红主播展开调查，目前已掌握确凿证据。相关直播平台已暂停其账号直播权限。',
    tag: '网红圈',
    time: '8小时前',
    hot: '6.5万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20art%20depicting%20financial%20investigation%20concept%2C%20documents%20and%20digital%20screens%20with%20red%20alert%20elements%2C%20warm%20amber%20lighting%2C%20serious%20atmosphere%2C%20modern%20editorial%20design%2C%20minimalist%20composition%20with%20clean%20lines%2C%20professional%20news%20media%20aesthetic&width=800&height=500&seq=card-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '综艺节目录制现场爆发激烈冲突，导演组紧急叫停',
    summary: '某热门综艺最新一期录制现场，两位嘉宾因观点不合爆发口角，随后升级为肢体冲突。节目组已发表声明致歉。',
    tag: '综艺',
    time: '12小时前',
    hot: '5.3万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20illustration%20of%20conflict%20on%20stage%20set%2C%20abstract%20figures%20in%20confrontation%2C%20warm%20spotlight%20and%20deep%20red%20accents%2C%20theatrical%20atmosphere%2C%20modern%20digital%20art%20style%2C%20cinematic%20composition%2C%20professional%20quality%20with%20soft%20shadows&width=800&height=500&seq=card-04-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '顶流男团成员被曝私联粉丝，聊天记录全网疯传',
    summary: '一组疑似男团成员与粉丝的私密聊天截图在网络疯传，内容涉及不当言论。经纪公司暂未回应此事。',
    tag: '娱乐圈',
    time: '1天前',
    hot: '4.8万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20concept%20of%20leaked%20chat%20messages%20on%20phone%20screen%2C%20glowing%20notification%20bubbles%2C%20warm%20red%20and%20amber%20color%20palette%2C%20social%20media%20scandal%20theme%2C%20modern%20editorial%20digital%20art%2C%20clean%20minimalist%20composition%2C%20professional%20news%20visual&width=800&height=500&seq=card-05-2026&orientation=landscape',
  },
  {
    id: 6,
    title: '知名导演涉嫌潜规则新人演员，多名受害者联合发声',
    summary: '多位年轻演员近日联合发声，指控某知名导演在试镜过程中存在不当行为。事件持续发酵，多家品牌已宣布终止合作。',
    tag: '社会热点',
    time: '2天前',
    hot: '3.1万',
    image: 'https://readdy.ai/api/search-image?query=Powerful%20editorial%20illustration%20about%20justice%20and%20speaking%20out%2C%20abstract%20figures%20standing%20together%2C%20warm%20red%20and%20golden%20lighting%2C%20empowering%20atmosphere%2C%20modern%20digital%20art%20style%2C%20minimalist%20composition%2C%20professional%20magazine%20quality%2C%20soft%20gradient%20background&width=800&height=500&seq=card-06-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门黑料
          </h2>
          <span className="text-sm text-foreground-500 flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line"></i>
            实时更新中
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardData.map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 rounded-xl border border-secondary-200/60 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={card.image}
                  alt={`${card.title} - 五一黑料网热门黑料`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  width="800"
                  height="500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 bg-background-950/70 text-background-50 text-xs rounded-md flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-fire-fill text-xs"></i>
                    {card.hot}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 line-clamp-2 font-heading group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1 text-primary-600 font-medium whitespace-nowrap cursor-pointer hover:text-primary-700">
                    阅读全文
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}